var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycSuspected240X240(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.799 39C108.843 39 101.781 40.5969 94.3123 42.7307C62.6508 51.7769 37.5 81.2694 37.5 114.5C37.5 174.838 94.3123 191.38 131.722 191.38C169.132 191.38 203.27 167.5 203.27 128.18C203.27 106.417 202.932 80.9774 186.712 64.7574C168.431 46.4764 142.12 39 116.799 39Z",
    fill: "white",
    stroke: "#C08550",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 75.5V117.5L160 147",
    stroke: "#C08550",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycSuspected240X240);
export default __webpack_public_path__ + "static/media/kyc-suspected-240x240.a2c5d572b4818522d8cafe1fe72ef67f.svg";
export { ForwardRef as ReactComponent };